import { useState } from 'react'
import styled from 'styled-components'

import { AlertsDialog } from 'modules/Settings/AlertsDialog'
import { useIsMobile } from 'utils/useIsMobile'
import { IconTelegram } from 'components/Icons/IconTelegram'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { useIsTelegramConnected } from 'utils/useIsTelegramConnected'

export const IconContainer = styled.div`
  display: flex;
  cursor: pointer;
`

export const TelegramNotifications = () => {
  const connectionStatus = useIsTelegramConnected()

  const [isDialogOpen, setDialogOpen] = useState(false)

  const openDialog = () => setDialogOpen(true)
  const closeDialog = () => setDialogOpen(false)

  const isMobile = useIsMobile()

  if (isMobile) {
    return null
  }

  return (
    <>
      <Tooltip
        content={connectionStatus?.isConnected ? 'Disconnect Telegram' : 'Connect Telegram to get notifications'}
        position="bottom"
        tooltipBoxStyles={connectionStatus?.isConnected ? { minWidth: '168px' } : { minWidth: '284px' }}
      >
        <IconContainer onClick={openDialog} style={{ marginRight: 16 }}>
          <IconTelegram />
        </IconContainer>
      </Tooltip>
      <AlertsDialog isOpen={isDialogOpen} onClose={closeDialog} />
    </>
  )
}
